import React, { useEffect, useState } from 'react';
import { candidacyService } from '@/shared/services/candidacyService';

export const FACULTY_OVER_LIMIT_TEXT =
    "This student can't be offered this position: it would pass the weekly hours or the number of positions the program allows them.";

const LOAD_ERROR = "The student's weekly hours couldn't be loaded.";

/**
 * The student's weekly hours as an offer-maker may see them. One request when
 * it mounts. Coordinators read the held hours and the limit; faculty read
 * only whether an offer would pass the limits, and nothing when it would not,
 * whatever else the response holds.
 */
export default function CommitmentSummary({ candidacyId, mode }) {
    const [commitment, setCommitment] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let active = true;
        setCommitment(null);
        setFailed(false);
        candidacyService
            .getCommitment(candidacyId)
            .then((answer) => {
                if (active) setCommitment(answer);
            })
            .catch(() => {
                if (active) setFailed(true);
            });
        return () => {
            active = false;
        };
    }, [candidacyId]);

    if (failed) return <p className="mb-0">{LOAD_ERROR}</p>;
    if (!commitment) return null;

    const over = commitment.withinLimits === false;
    if (mode !== 'coordinator') {
        return over ? (
            <div className="alert alert-warning mb-0">
                {FACULTY_OVER_LIMIT_TEXT}
            </div>
        ) : null;
    }

    const held = commitment.positions;
    return (
        <div>
            <p className="mb-1">
                {`Holds ${commitment.heldHours} hours a week in accepted positions, with ${commitment.offerHours} more in outstanding offers. Limit ${commitment.limit} hours, ${commitment.remaining} left. This position is ${commitment.hoursPerWeek} hours a week.`}
            </p>
            <p className="mb-1">
                {`Holds ${held} ${held === 1 ? 'position' : 'positions'} this term.`}
            </p>
            {over && (
                <div className="alert alert-warning mb-0">
                    An offer would pass the weekly hours or the number of
                    positions the program allows this student.
                </div>
            )}
        </div>
    );
}
